import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '../input/input.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [ReactiveFormsModule, InputComponent],
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  @Output() changePasswordEvent = new EventEmitter<any>();
  private _fb = inject(FormBuilder);
  protected formChangePassword!: FormGroup;

  ngOnInit(): void {
    this.loadForm();
  }

  private loadForm() {
    this.formChangePassword = this._fb.group({
      password: [''],
      currentPassword: [''],
      passwordConfirmation: [''],
    });
  }

  onSubmit() {
    this.changePasswordEvent.emit(this.formChangePassword.value);
  }
}
